import { render, staticRenderFns } from "./fixed-coupon-package.mpx?vue&type=template&id=7440708e&scoped=true&component=true&componentId=fixed-coupon-package04913210"
import script from "./fixed-coupon-package.mpx?vue&type=script&lang=js&component=true&componentId=fixed-coupon-package04913210"
export * from "./fixed-coupon-package.mpx?vue&type=script&lang=js&component=true&componentId=fixed-coupon-package04913210"
import style0 from "./fixed-coupon-package.mpx?vue&type=style&index=0&id=7440708e&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m04913210%22%7D&component=true&componentId=fixed-coupon-package04913210"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7440708e",
  null
  
)

export default component.exports